import React from 'react';
import ReactDOM from 'react-dom/client';
import { SpineWhatIfPage } from './SpineWhatIfPage';
import { SafeBoundary } from '@/components/SafeBoundary';
import { initMonitoring } from '@/lib/monitoring';
import '../index.css';
import './spine.css';

initMonitoring('spine');

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <SafeBoundary section="Spine What-If">
      <SpineWhatIfPage />
    </SafeBoundary>
  </React.StrictMode>
);
